import React from "react";
import { Link, BrowserRouter as Router, Routes, Route } from "react-router-dom";
import GPAPredict from "./Components/GPAPredict";
import GradePredict from "./Components/GradePredict";
import CGPAPredict from "./Components/CGPAPredict";
import AttendanceCalc from "./Components/AttendanceCalc";
import { FaHeart } from "react-icons/fa";

function Home() {
    return (
        <div className="app-shell">
            <main className="page">
                <header className="page-header">
                    <p className="eyebrow">GradeGuru</p>
                    <h1 className="page-title">VIT GPA &amp; Grade Calculator</h1>
                    <p className="lede">
                        A calm workspace to plan credits, predict grades, and keep attendance on track the
                        night before results.
                    </p>
                </header>

                <section className="home-hero">
                    <h2 className="hero-title">Night-before-ready toolkit</h2>
                    <p className="lede" style={{ marginTop: 8 }}>
                        Built for VIT Vellore students: GPA, grade prediction, CGPA tracking, and attendance
                        projection in one focused place.
                    </p>
                    <div className="hero-actions">
                        <Link to="/gpa-predictor" className="btn btn-primary">Start with GPA</Link>
                        <a href="https://techyalhan.com" className="btn btn-secondary" target="_blank" rel="noreferrer">
                            techyalhan.com ↗
                        </a>
                    </div>
                </section>

                <section className="card">
                    <div className="card-heading">
                        <div>
                            <h2 className="card-title">Pick a tool</h2>
                            <p className="section-note">Everything you need for credit planning and attendance safety.</p>
                        </div>
                    </div>
                    <div className="home-grid">
                        <Link to="/gpa-predictor" className="home-tile">
                            <p className="tile-title">GPA Predictor</p>
                            <p className="tile-meta">Compute GPA using course credits and your expected grades.</p>
                            <span className="tile-cta">Open</span>
                        </Link>

                        <Link to="/grade-predictor" className="home-tile">
                            <p className="tile-title">Grade Predictor</p>
                            <p className="tile-meta">Estimate grades from marks and preview your approximate GPA.</p>
                            <span className="tile-cta">Open</span>
                        </Link>

                        <Link to="/cgpa-calculator" className="home-tile">
                            <p className="tile-title">CGPA Calculator</p>
                            <p className="tile-meta">Track semester GPAs and see your cumulative average.</p>
                            <span className="tile-cta">Open</span>
                        </Link>

                        <Link to="/attendance-calculator" className="home-tile">
                            <p className="tile-title">Attendance Calculator</p>
                            <p className="tile-meta">Project attendance after taking leave days.</p>
                            <span className="tile-cta">Open</span>
                        </Link>
                    </div>
                </section>

                <section className="card">
                    <h3 className="card-title" style={{ marginBottom: 12 }}>How to use</h3>
                    <div className="list-steps">
                        <div className="step">
                            <h4>1. Add subjects</h4>
                            <p className="muted">Enter credits and marks; the app keeps your data in this browser.</p>
                        </div>
                        <div className="step">
                            <h4>2. Calculate</h4>
                            <p className="muted">Hit calculate to see GPA, CGPA, or attendance instantly.</p>
                        </div>
                        <div className="step">
                            <h4>3. Act</h4>
                            <p className="muted">Use the personalized feedback to decide next steps for VIT thresholds.</p>
                        </div>
                    </div>
                </section>

                <section className="card">
                    <h3 className="card-title" style={{ marginBottom: 12 }}>VIT quick tips</h3>
                    <div className="tip">Keep attendance ≥ 75% to stay clear of proctor calls; plan leaves in advance.</div>
                    <div className="tip">Aim for S/A in core slots to buffer electives; GPA weights follow credits.</div>
                    <div className="tip">Update CGPA each semester so you know your scholarship or placement bracket.</div>
                </section>

                <div className="footer">
                    Built with ♥ by <strong>techyalhan.com</strong> - GradeGuru (For VITians)
                </div>
            </main>
        </div>
    );
}

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gpa-predictor" element={<GPAPredict />} />
                <Route path="/grade-predictor" element={<GradePredict />} />
                <Route path="/cgpa-calculator" element={<CGPAPredict />} />
                <Route path="/attendance-calculator" element={<AttendanceCalc />} />
            </Routes>
        </Router>
    );
}

export default App;